import { Component, EventEmitter, inject, OnDestroy, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { StateNotifyService } from '../../../../common/state/service/state-notify.service';
import { VesselMachinery } from '../../dto/vessel-machinery';
import { VesselMachineryDetailsComponent } from '../vessel-machinery-details/vessel-machinery-details.component';
import { Vessel } from '../../dto/vessel';
import { Subject, takeUntil } from 'rxjs';
import { VesselMachineryService } from '../../service/vessel-machinery.service';

@Component({
  selector: 'dpi-vessel-machinery-list',
  imports: [MatCardModule, MatTableModule, MatIconModule, MatButtonModule, MatToolbarModule, MatDialogModule, MatTooltipModule, NgIf],
  templateUrl: './vessel-machinery-list.component.html',
  styleUrl: './vessel-machinery-list.component.scss'
})
export class VesselMachineryListComponent implements OnInit, OnDestroy {
  vessel: Vessel;
  displayedColumns: string[] = ['name', 'description'];
  dataSource: VesselMachinery[] = [];
  destroyed$ = new Subject<void>(); // notifier of component destroyed
  @Output('listSizeChanged') listSize = new EventEmitter<number>();
  isReadonly: boolean;
  private _dialog = inject(MatDialog);

  constructor(private notifyService: StateNotifyService, private machineryService: VesselMachineryService) {
    this.vessel = this.notifyService.getSelectedVessel();
    this.isReadonly = true;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.notifyService.vesselSelection$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(model => {
        this.vessel = model;
        this.reloadListMachinery(model);
      })

    this.notifyService.readonlyMode$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(res => {
        this.isReadonly = res;
      });
  }

  reloadListMachinery(selectedVessel: Vessel) {
    this.machineryService.getAllMachineriesOfVessel(selectedVessel.id)
    .pipe(takeUntil(this.destroyed$))
    .subscribe({
      next: (res: any) => {
        this.dataSource = res;
        this.listSize.emit(this.dataSource.length);
      },
      error: (error: any) => {
        console.error('Error: ', error);
        this.dataSource = [];
      }
    })
  }

  selectVesselMachinery(selected: VesselMachinery) {
    if (!this.isReadonly) {
      var objCopy: VesselMachinery = { ...selected };
      const dialogRef = this._dialog.open(VesselMachineryDetailsComponent, { data: objCopy });
      dialogRef.afterClosed()
        .pipe(takeUntil(this.destroyed$))
        .subscribe(result => {
          if (result !== undefined) {
            if (dialogRef.componentInstance.isToUpdate) {
              this.update(dialogRef.componentInstance.vesselMachinery);
            }
          } else if (dialogRef.componentInstance.isToDelete) {
            this.delete(dialogRef.componentInstance.vesselMachinery.id);
          }
        });
    }
  }
  
   //--- CRUD actions ---
  
    create() {
      this.machineryService.createMachinery(this.vessel.id)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: model => {
            this.addNewModelToDataSource(model);
            this.selectVesselMachinery(model);
          },
          error: err => { console.log(err); }
        });
    }
  
    private addNewModelToDataSource(model: VesselMachinery) {
      let list: VesselMachinery[] = [];
      for (var item of this.dataSource) {
        list.push(item);
      }
      list.push(model);
      this.dataSource = list;
      this.listSize.emit(this.dataSource.length);
    }
  
    update(model: VesselMachinery) {
      this.machineryService.updateMachinery(model)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: res => {
            this.replaceModelInDataSource(res);
          },
          error: err => { console.log(err); }
        });
    }
  
    private replaceModelInDataSource(model: VesselMachinery) {
      let list: VesselMachinery[] = [];
      for (var item of this.dataSource) {
        if (item.id === model.id) {
          list.push(model);
        } else {
          list.push(item);
        }
      }
      this.dataSource = list;
      this.listSize.emit(this.dataSource.length);
    }
  
    delete(modelId: number) {
      this.machineryService.deleteMachinery(modelId)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: res => {
            this.removeModelFromDataSource(modelId);
          },
          error: err => { console.log(err); }
        });
    }
  
    private removeModelFromDataSource(modelId: number) {
      let list: VesselMachinery[] = [];
      for (var item of this.dataSource) {
        if (item.id === modelId) {
          //the model is to be removed --> do nothing
        } else {
          list.push(item);
        }
      }
      this.dataSource = list;
      this.listSize.emit(this.dataSource.length);
    }
  

}
